import { EventFinishActionRequestBM } from '@cue/api';
import { ReservationWithHint } from '../models';

export function getEventFinishRequests(
  event: Pick<
    ReservationWithHint,
    'id' | 'resourceAttendees' | 'subject' | 'showAs' | 'start' | 'end' | 'iCalUId' | 'organizer'
  >
): EventFinishActionRequestBM[] {
  return event.resourceAttendees.map(({ resource }) => ({
    data: {
      id: event.id,
      resourceUsername: resource.username,
      subject: event.subject,
      showAs: event.showAs.value,
      originalRealStart: event.start.utcDateTime,
      originalRealEnd: event.end.utcDateTime,
      realStart: event.start.utcDateTime,
      realEnd: event.end.utcDateTime,
      iCalUId: event.iCalUId,
      action: 'finish',
      doneBy: 'assist',
      resourceDisplayName: resource.name,
      organiserName: event.organizer?.emailAddress?.name ?? '',
      organiserEmail: event.organizer?.emailAddress?.address ?? '',
    },
  }));
}
